import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { CardList } from '@shared/models/card-list';
import { Cacheable } from 'ts-cacheable';
import { Config } from '@core/config';

@Injectable({
  providedIn: 'root',
})
export class CardsService {
  public keywordList: string[] = [];

  constructor(private httpClient: HttpClient) {}

  createKW() {
    this.getCardList().subscribe((r: CardList[]) => {
      for (const card of r) {
        if (!this.keywordList.includes(card.title.toLowerCase())) {
          this.keywordList.push(card.title.toLowerCase());
        }
        if (!this.keywordList.includes(card.city.name?.toLowerCase())) {
          this.keywordList.push(card.city.name?.toLowerCase());
        }
      }
    });
  }

  @Cacheable({ maxAge: 100000 })
  getCardList(id?: string): Observable<CardList[]> {
    return this.httpClient.get<CardList[]>(
      `${Config.serverUrl}fiche${id !== undefined ? '?categId=' + id : ''}`,
      {
        responseType: 'json',
      }
    );
  }

  getCardListPromise(id?: string): Promise<CardList[]> {
    return this.httpClient
      .get<CardList[]>(
        `${Config.serverUrl}fiche${id !== undefined ? '?categId=' + id : ''}`,
        {
          responseType: 'json',
        }
      )
      .toPromise();
  }
}
